// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_revoslider.scss
// module id = 49
// module chunks = 0